(function(){
  if (window.__tsnHoverVideoInit) return;
  window.__tsnHoverVideoInit = true;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (!canHover) return;
  var css = '.product-card--image-wrapper{position:relative;}'
    + '.product-card--hover-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .35s ease;pointer-events:none;z-index:3;}'
    + '.product-card--root:hover .product-card--hover-video.tsn-ready,.product-card--root:focus-within .product-card--hover-video.tsn-ready{opacity:1;}';
  var style = document.createElement('style');
  style.setAttribute('data-tsn-hover-video','');
  style.textContent = css;
  document.head.appendChild(style);
  var bound = new WeakSet();
  function prepare(video){
    if (video.dataset.tsnLoaded === '1') return Promise.resolve();
    video.querySelectorAll('source[data-src]').forEach(function(s){ if(!s.getAttribute('src')) s.setAttribute('src', s.getAttribute('data-src')); });
    video.dataset.tsnLoaded = '1';
    video.load();
    return new Promise(function(resolve){
      if (video.readyState >= 2) return resolve();
      var done=function(){ video.removeEventListener('loadeddata',done); resolve(); };
      video.addEventListener('loadeddata', done);
    });
  }
  function play(card){
    var v = card.querySelector('.product-card--hover-video');
    if (!v) return;
    prepare(v).then(function(){ v.classList.add('tsn-ready'); var p=v.play(); if(p&&p.catch)p.catch(function(){}); });
  }
  function stop(card){
    var v = card.querySelector('.product-card--hover-video');
    if (!v) return;
    try { v.pause(); v.currentTime = 0; } catch(e){}
  }
  function bind(card){
    if (bound.has(card)) return;
    if (!card.querySelector('.product-card--hover-video')) return;
    bound.add(card);
    card.addEventListener('mouseenter', function(){ play(card); });
    card.addEventListener('mouseleave', function(){ stop(card); });
    card.addEventListener('focusin', function(){ play(card); });
    card.addEventListener('focusout', function(){ if(!card.contains(document.activeElement)) stop(card); });
  }
  function scan(root){ (root||document).querySelectorAll('.product-card--root').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  else scan(document);
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){ var m=muts[i];
      for (var j=0;j<m.addedNodes.length;j++){ var n=m.addedNodes[j];
        if (n.nodeType===1){ if (n.matches && n.matches('.product-card--root')) bind(n); else if (n.querySelectorAll) scan(n); }
      }
    }
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();